import React, { useState } from 'react';
import { Section } from '../ui/Section';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/Accordion'; // Will need to create this or use simple disclosure
// Since I don't have the Accordion component in context, I'll build a simple one here or just list them.
// I'll build a simple disclosure component inline for simplicity and robustness.

import { ChevronDown } from 'lucide-react';
function ObjectionItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-neutral-800" data-id="element-48">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-4 flex justify-between items-center text-left focus:outline-none" data-id="element-49">
        <span className="text-white font-bold text-lg" data-id="element-50">{question}</span>
        <ChevronDown className={`text-neutral-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-51" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-40 opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-52">
        <p className="text-neutral-400" data-id="element-53">{answer}</p>
      </div>
    </div>;
}
export function ObjectionsSection() {
  const objections = [{
    q: '“No tengo tiempo.”',
    a: 'Por eso es 10 minutos al día. No es un curso. Es un sistema de supervivencia.'
  }, {
    q: '“Estoy demasiado cansado.”',
    a: 'Perfecto. Esto está hecho para cansados. Empieza con 2 mínimos de energía.'
  }, {
    q: '“Mi situación es complicada.”',
    a: 'Por eso el sistema no depende de una sola jugada. Te da rutas flexibles.'
  }, {
    q: '“Y si mi trabajo es tóxico de verdad…”',
    a: 'Entonces más necesitas No‑drama + Archivo + Transición. Explosión = más daño.'
  }];
  return <Section variant="dark" data-id="element-54">
      <h2 className="text-3xl font-bold text-white uppercase tracking-tight mb-8" data-id="element-55">
        Objeciones honestas
      </h2>
      <div className="space-y-2" data-id="element-56">
        {objections.map((obj, i) => <ObjectionItem key={i} question={obj.q} answer={obj.a} data-id="element-57" />)}
      </div>
    </Section>;
}